import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TableBody from '@material-ui/core/TableBody'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import EditIcon from '@material-ui/icons/Edit'
import SkeletonTable from '../../../common/skeleton-table'
import Y from '../../../y18n'
import TableToolbar from '../../../common/table-toolbar'
import * as simcardActions from '../../../store/simcards'
import * as productActions from '../../../store/products'
import Styles from '../../../common/styles'
import CountriesDropdown from '../../../common/dropdowns/countries-dropdown'

const mapStateToProps = state => ({
  simcards: state.simcards,
  products: state.products
})

const mapDispatchToProps = dispatch => ({
  simcardActions: bindActionCreators(simcardActions, dispatch),
  productActions: bindActionCreators(productActions, dispatch)
})

class SimcardsTable extends Component {
  componentDidMount () {
    this.props.simcardActions.getSimcards()
    this.props.productActions.getProducts()
  }

  componentWillUnmount () {
    this.props.simcardActions.clearSimcards()
  }

  handleLanguageFilterChange = event => {
    const value = event.target.value

    this.props.simcardActions.setFilter('country', value)
  }

  filterSimcards = simcards => {
    const countryFilter = simcards.filter.country

    if (!countryFilter) return simcards

    const items = simcards.items.filter(u => u.country === countryFilter)
    const itemCount = items.length

    return { ...simcards, items, itemCount }
  }

  confirmDialog = (message, proceed, abort, item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <h1>{Y`Confirm`}</h1>
            <p>{message}</p>
            <p>{Y`Do you want to proceed`}</p>
            <br/>
            <div className={this.props.classes.reactConfirmButtonGroup}>
              <button 
                className={this.props.classes.reactConfirmButtonGroupBtnNeutral}
                onClick={() => {
                  if(item)
                    abort(item)
                  else
                    abort()
                  onClose()
                }}>{Y`Cancel`}
              </button>
              <button
                className={this.props.classes.reactConfirmButtonGroupBtnWarning}
                onClick={() => {
                  if(item)
                    proceed(item)
                  else
                    proceed()
                  onClose()
                }}
              >
              {Y`Ok`}
              </button>
            </div>
          </div>
        )
      }
    })
  }

  render () {
    const { simcards: unfilteredSimcards, simcardActions, classes } = this.props

    const simcards = this.filterSimcards(unfilteredSimcards)
    return (
      <div>
        <TableToolbar store={simcards} storeActions={simcardActions} title={Y`Simcards`} />
        <div style={{ paddingLeft: 24, paddingRight: 24 }}>
          <CountriesDropdown
            value={simcards.filter.country}
            handleChange={this.handleLanguageFilterChange}
            alwaysShowDefaultOption
          />
        </div>
        <div className={classes.tableWrapper}>
          <Table className={'striped'}>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell numeric>
                  <TableSortLabel
                    active={simcards.sort.orderBy === 'imsi'}
                    direction={simcards.sort.direction}
                    onClick={this.handleSortChange('imsi')}
                  >
                    {Y`IMSI`}
                  </TableSortLabel>
                </TableCell>
                <TableCell numeric>
                  <TableSortLabel
                    active={simcards.sort.orderBy === 'msisdn'}
                    direction={simcards.sort.direction}
                    onClick={this.handleSortChange('msisdn')}
                  >
                    {Y`MSISDN`}
                  </TableSortLabel>
                </TableCell>
                <TableCell numeric>
                  <TableSortLabel
                    active={simcards.sort.orderBy === 'icc'}
                    direction={simcards.sort.direction}
                    onClick={this.handleSortChange('icc')}
                  >
                    {Y`ICC`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={simcards.sort.orderBy === 'productName'}
                    direction={simcards.sort.direction}
                    onClick={this.handleSortChange('productName')}
                  >
                    {Y`Product name`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={simcards.sort.orderBy === 'verificationCode'}
                    direction={simcards.sort.direction}
                    onClick={this.handleSortChange('verificationCode')}
                  >
                    {Y`Verification code`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={simcards.sort.orderBy === 'country'}
                    direction={simcards.sort.direction}
                    onClick={this.handleSortChange('country')}
                  >
                    {Y`Country`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={simcards.sort.orderBy === 'status'}
                    direction={simcards.sort.direction}
                    onClick={this.handleSortChange('status')}
                  >
                    {Y`Status`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={simcards.sort.orderBy === 'smsStatus'}
                    direction={simcards.sort.direction}
                    onClick={this.handleSortChange('smsStatus')}
                  >
                    {Y`SMS Status`}
                  </TableSortLabel>
                </TableCell>
                <TableCell padding='checkbox'>
                  <Checkbox
                    checked={simcards.allSelected}
                    onChange={() => this.handleCheckAll()}
                    classes={{ checked: classes.checked }}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {simcards.loading
                ? <SkeletonTable rows={simcards.rowsPerPage} cols={10} />
                : simcards.sort.direction === 'desc'
                    ? simcards.items
                        .sort((a, b) => (b[simcards.sort.orderBy] <= a[simcards.sort.orderBy] ? -1 : 1))
                        .slice(
                          simcards.page * simcards.rowsPerPage,
                          simcards.page * simcards.rowsPerPage + simcards.rowsPerPage
                        )
                        .map(simcard => this.renderSimcard(simcard))
                    : simcards.items
                        .sort((a, b) => (a[simcards.sort.orderBy] <= b[simcards.sort.orderBy] ? -1 : 1))
                        .slice(
                          simcards.page * simcards.rowsPerPage,
                          simcards.page * simcards.rowsPerPage + simcards.rowsPerPage
                        )
                        .map(simcard => this.renderSimcard(simcard))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={simcards.itemCount}
                  rowsPerPage={simcards.rowsPerPage}
                  page={simcards.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </div>
    )
  }

  renderSimcard (simcard) {
    return (
      <TableRow key={simcard.id} role='checkbox' aria-checked={simcard.checked}>
        <TableCell>
          <IconButton title={Y`Edit simcard`} onClick={() => this.props.simcardActions.setActive(simcard)}>
            <EditIcon />
          </IconButton>
        </TableCell>
        <TableCell numeric>{simcard.imsi}</TableCell>
        <TableCell numeric>{simcard.msisdn}</TableCell>
        <TableCell numeric>{simcard.icc}</TableCell>
        <TableCell>{simcard.productName}</TableCell>
        <TableCell>{simcard.verificationCode}</TableCell>
        <TableCell>{Y`${simcard.country}`}</TableCell>
        <TableCell>
          <span style={{ color: simcard.status === 'Active' ? 'green' : 'red' }}>{Y`${simcard.status}`}</span>
        </TableCell>
        <TableCell>
          <span style={{ color: simcard.smsStatus === 'Active' ? 'green' : 'red' }}>{Y`${simcard.smsStatus}`}</span>
        </TableCell>
        <TableCell padding='checkbox'>
          <Checkbox
            checked={simcard.checked}
            onChange={() => this.handleCheck(simcard)}
            classes={{ checked: this.props.classes.checked }}
          />
        </TableCell>
      </TableRow>
    )
  }

  handleCheckAll = checked => {
    if(this.props.simcards.selectedItems.length === 0){
      this.confirmDialog(Y`Caution! You've selected multiple simcards that, may or may not have subscriptions attached to them. Are you really sure you want to proceed?. (You will still need to press the delete button)`,
      () => {this.props.simcardActions.toggleAll(this.props.simcards.allSelected)},
      () => {}
      )
    }else{
      this.props.simcardActions.toggleAll(this.props.simcards.allSelected)
    }
    
  }

  handleCheck = item => {
    
    if(item.dangerousToRemove && !item.checked){

      const abort = (item) => {
        this.props.simcardActions.unselectItem(item)
      }

      const proceed = (item) => {
        this.props.simcardActions.selectItem(item)
      }

      this.confirmDialog(Y`Caution! This Simcard has subscriptions connected to it. Deleting this will also delete the subscription conntected to it. Mark as checked anyway? (You will still need to press delete button)`, proceed, abort, item)
    }
    else {
      item.checked ? this.props.simcardActions.unselectItem(item) : this.props.simcardActions.selectItem(item)
    }
  }

  handleSortChange = value => event => {
    this.props.simcardActions.setSort(value)
  }

  handleChangePage = (event, page) => {
    this.props.simcardActions.setPage(page)
    this.props.simcardActions.getSimcards()
  }

  handleChangeRowsPerPage = event => {
    this.props.simcardActions.setRowsPerPage(event.target.value)
    this.props.simcardActions.getSimcards()
  }

  handleFilterChange = filterType => e => {
    let filter = { ...this.props.products.filter }
    filter[filterType] = e.target.value
    this.props.simcardActions.setFilter(filterType, e.target.value)
  }
}

SimcardsTable = connect(mapStateToProps, mapDispatchToProps)(SimcardsTable)
export default withStyles(Styles)(SimcardsTable)



// WEBPACK FOOTER //
// ./src/pages/simcards/containers/simcards-table.js